/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { FileInput } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';

const NS = '/bff/v1/j10-s02-solicitante-complementar-solicitacao';
export function ComplementarSolicitacaoPage() {
  const [estado, setEstado] = useState<any>();
  const [descricao, setDescricao] = useState(
    'A alteração requerida é a atualização formal da observação operacional, conforme comprovante apresentado.',
  );
  const [ocupado, setOcupado] = useState(false);
  async function chamar(caminho: string, corpo?: unknown) {
    setOcupado(true);
    try {
      const r = await chamarApi<any>(NS + caminho, {
        metodo: caminho === '/state' ? 'GET' : 'POST',
        corpo,
      });
      setEstado(r.state);
    } finally {
      setOcupado(false);
    }
  }
  useEffect(() => {
    void chamar('/state');
  }, []);
  if (!estado) return <p role="status">Carregando complementos…</p>;
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <FileInput className="mr-2 inline" />
        {estado.titulo}
      </h1>
      <p>{estado.descricao}</p>
      {estado.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      {estado.pedidos.map((p: any) => {
        const pendencia = p.pendencias.find((x: any) => x.status === 'ABERTA');
        return (
          <article className="space-y-3 rounded-md border p-4" key={p.id}>
            <h2 className="font-semibold">
              {p.protocolo} · versão {p.versao}
            </h2>
            <p>Fila atual: {p.fila}</p>
            {pendencia && (
              <>
                <p>{pendencia.motivo}</p>
                <p>Prazo: {pendencia.prazo_em}</p>
                <p>Campos liberados: {pendencia.campos_liberados.join(', ')}</p>
                <label>
                  Complemento
                  <textarea
                    aria-label="Descrição complementar"
                    className="block min-h-28 w-full rounded-md border bg-background p-2"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                  />
                </label>
                <Button
                  disabled={ocupado || descricao.length < 20}
                  onClick={() =>
                    void chamar('/verbs/enviar_complemento', {
                      pendenciaId: pendencia.id,
                      descricao,
                      comprovanteNome: 'complemento-solicitacao.txt',
                      comprovanteMime: 'text/plain',
                      comprovanteBase64: btoa(
                        'Comprovante atualizado do complemento ' + pendencia.id,
                      ),
                      chaveIdempotencia: crypto.randomUUID(),
                    })
                  }
                >
                  Enviar nova versão
                </Button>
              </>
            )}
          </article>
        );
      })}
      {estado.resultado && (
        <p role="status">Operação persistida: {JSON.stringify(estado.resultado)}</p>
      )}
    </main>
  );
}
